import { AuthConfig } from 'src/app/shared/authentication/auth.config';
import { LoggingConfiguration } from 'src/app/shared/shared-base/amg-ui/logging/logging/logging.config';
import { TcsConfig } from 'src/app/shared/tcs/tcs.config';
import { ApplicationInsightsConfiguration } from 'src/util/app-insights';
import { DoorbellConfiguration } from 'src/util/doorbell';
import { IntercomConfiguration } from 'src/util/intercom';
import { OktaConfiguration } from '../lib/fl-identity/fl-okta.config';
import { FlightLogApiConfiguration } from './shared/flight-log-api/flight-log-api-configuration';

export interface ClientConfiguration {
  flightLog: FlightLogApiConfiguration;
  auth: AuthConfig;
  applicationInsights: ApplicationInsightsConfiguration;
  logging: LoggingConfiguration;
  doorbell: DoorbellConfiguration;
  intercom: IntercomConfiguration;
  tcs: TcsConfig;
  okta: OktaConfiguration;
}

export interface ClientContext {
  environment: 'Local' | 'Development' | 'QA' | 'Production' | 'Training';
  configuration: ClientConfiguration;
}

export const configuration: ClientConfiguration = clientContext.configuration;

export const isTcsUrl = (url: string) => url.includes(configuration.tcs.graphQLUri);
export const isFlightLogUrl = (url: string) => url.includes(configuration.flightLog.baseUri);
export const isTcsOrFlightLogUrl = (url: string) => isTcsUrl(url) || isFlightLogUrl(url);
